import "./ModalPg.css"
import React, { useState } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import MuiModal from '@mui/material/Modal';
import { Stack } from "@mui/material";



function ModalPg({ isOpen, title, description, handleClose, handleYesClk, handleNoClk }) {



  const handleBtnClick = () => {
    isOpen = false;
  }

  return (
    <MuiModal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"

    >
      <Box id="modalScreen">
        <Typography id="modal-title" variant="h6" component="h2">
          {title}
        </Typography>
        <Typography id="modal-description" sx={{ mt: 1, mb: 2 }}>
          {description}
        </Typography>
        <Stack direction="row" spacing={2}>
          <Button onClick={handleNoClk} variant="outlined">No</Button>
          <Button onClick={handleYesClk} variant="contained" href="#text-buttons" sx={{ backgroundColor: '#133d64' }}>Yes</Button>
        </Stack>

      </Box>

    </MuiModal>
  );
}

export default ModalPg;


